import { Injectable } from '@angular/core';

@Injectable()
export class LoaderService {

	constructor() { }

	show() {
		$('.lds-dual-ring').show(500);
	}

	hide() {
		$('.lds-dual-ring').hide(500);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/loader/loader.service.ts